const containsVariable = (txt) => /{.*?}/.test(txt)

export const replaceVars = (chart, variables) => {
  if (!variables) return chart

  try {
    variables = JSON.parse(variables)
  } catch (e) {
    console.log('qualifio charts: object malformed')
    console.log(variables)
    console.log(e)
    return chart
  }

  let label = chart.label
  if (containsVariable(label)) {
    const matches = label.match(/{.*?}/g)
    matches.forEach(x => {
      label = label.replace(new RegExp(x, 'g'), variables[x])
    })
  }

  chart.label = label
  return chart
}



// WEBPACK FOOTER //
// ./src/helpers/variables.js